module.exports = __webpack_public_path__ + "static/oplataMini-f2dfdbe189dbfe99eb05c0d6baca6d67.png";